import React from "react";
import {
  Button,
  Grid,
  MenuItem,
  TextField,
  Toolbar,
  Tooltip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Controller } from "react-hook-form";
import { Add } from "@mui/icons-material";

const InputFieldOrder = ({
  fieldName,
  errors,
  remove,
  fieldsArray,
  watch,
  register,
  handleImageFunc,
  clearErrorsfunc,
  handleUrlChangefunc,
  control,
  appendfunc,
}) => {
  return (
    <div>
      {fieldsArray?.map((item, index) => (
        <div key={item.id} className="">
          <div className="d-flex justify-content-around mb-3 mt-2">
            <Button
              variant="contained"
              component="label"
              {...register(`${fieldName}.file`)}
              onClick={() => clearErrorsfunc(`${fieldName}.file`)} // Clear errors for URL when file input is clicked
            >
              Upload File
              <input
                type="file"
                {...register(`${fieldName}.file`)}
                hidden
                onChange={(e) => handleImageFunc(index, `${fieldName}`, e)}
                className={`file_button mb-1 ${
                  errors[fieldName] && errors[fieldName][index]?.file
                    ? "error"
                    : ""
                }`}
              />
            </Button>
            {(watch(`${fieldName}[${index}].image`) ||
              watch(`${fieldName}[${index}].logo`)) && (
              <div className="image_div">
                <img
                  src={
                    watch(`${fieldName}[${index}].image`) ||
                    watch(`${fieldName}[${index}].logo`)
                  }
                  alt=""
                  width={100}
                  height="auto"
                  className="rounded image"
                />
              </div>
            )}
          </div>
          <div className="column mb-2">
            <Controller
              name={`${fieldName}[${index}].file`}
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Enter Banner Url"
                  className={`w-100 mb-2 ${
                    errors[fieldName] && errors[fieldName][index]?.file
                      ? "error"
                      : ""
                  }`}
                  value={field.value || ""}
                  onChange={(e) =>
                    handleUrlChangefunc(index, `${fieldName}`, e)
                  }
                />
              )}
            />
            <Controller
              name={`${fieldName}[${index}].link`}
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Enter Link"
                  className={`w-100 mb-2 ${
                    errors[fieldName] && errors[fieldName][index]?.link
                      ? "error"
                      : ""
                  }`}
                />
              )}
            />
          </div>
          <div className="d-flex gap-3 mb-2">
            <Controller
              name={`${fieldName}[${index}].target`}
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Enter Target"
                  select
                  className={`w-100 mb-2 ${
                    errors[fieldName] && errors[fieldName][index]?.target
                      ? "error"
                      : ""
                  }`}
                >
                  <MenuItem value="_self">_self</MenuItem>
                  <MenuItem value="_blank">_blank</MenuItem>
                </TextField>
              )}
            />
            <Controller
              name={`${fieldName}[${index}].order`}
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  select
                  label="Enter Order"
                  className={`w-100 mb-2 ${
                    errors[fieldName] && errors[fieldName][index]?.order
                      ? "error"
                      : ""
                  }`}
                >
                  {[...Array(15).keys()].map((number) => (
                    <MenuItem key={number + 1} value={(number + 1).toString()}>
                      {number + 1}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            />
          </div>
          <div className="column mb-2">
            <Controller
              name={`${fieldName}[${index}].alt`}
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Enter Alt"
                  className={`w-100 mb-2 ${
                    errors[fieldName] && errors[fieldName][index]?.alt
                      ? "error"
                      : ""
                  }`}
                />
              )}
            />
          </div>
          <div className="d-flex justify-content-end">
            {fieldsArray?.length > 0 && (
              <Tooltip title="Delete" arrow>
                <DeleteIcon
                  onClick={() => remove(index)}
                  style={{ color: "red", cursor: "pointer" }}
                />
              </Tooltip>
            )}
          </div>
        </div>
      ))}
      <Grid className="d-flex justify-content-between">
        <Tooltip title="Add" arrow>
          <Button
            className="button "
            variant="outlined"
            disableElevation
            startIcon={<Add />}
            onClick={() =>
              appendfunc({
                file: null,
                link: "",
                target: "",
                order: "",
                alt: "",
              })
            }
          >
            Add
          </Button>
        </Tooltip>
      </Grid>
    </div>
  );
};

export default InputFieldOrder;
